const itemKey = 'ns-simplified-signup-session-id';

/**
 * Get a stored session ID
 * @return {(string | null)}
 */
export function getSessionId() {
    return sessionStorage.getItem(itemKey);
}

/**
 * Store a session ID
 * @param {string} value session ID
 */
export function setSessionId(value) {
    if (value) {
        sessionStorage.setItem(itemKey, value);
    } else {
        sessionStorage.removeItem(itemKey);
    }
}
